import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import QRCode from "qrcode";

import { env, IENVIRONMENT } from "./env.service";

import {SignUpStepRoutes, SignUpSteps} from "../interfaces/Navigation";

export class HTTPService {

    public axiosInstance!: AxiosInstance


    constructor(){
        this.axiosInstance = this.setUpAxios()
    }
    
    private getAPIBaseURL(): string {
        switch(env.ENVIRONMENT) {
            case IENVIRONMENT.QA:
                return `https://api.tab-qa.com/`;
            case IENVIRONMENT.PRODUCTION:
                return `https://api.theappbuilder.com/`;
            case IENVIRONMENT.LOCAL:
                return `https://api.tab-dev.com/`;
            case IENVIRONMENT.FEATURE:
                return `https://api.${env.FEATURENAME!}.tab-feature.com/`
            default:
                return '##DevApiUrl##';
        }
    }

    private setUpAxios = (): AxiosInstance  => {

        let axiosInstance  = this.axiosInstance;
        
      
        const baseUrlHasChanged = this.getAPIBaseURL() 
        if(!this.axiosInstance || baseUrlHasChanged) {
            axiosInstance = axios.create({
                baseURL: this.getAPIBaseURL(),
            });
        }
        // if token
        /*if(axiosInstance?.defaults?.headers?.common) {
            axiosInstance.defaults.headers.common['Authorization'] =  `Bearer ${localStorage.getItem('token')}`
        }
        */
        return axiosInstance
    }

    public get = (url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> => {
        return this.setUpAxios().get(url, options); 
    }

    public  post(url: string, payload: object, options?: AxiosRequestConfig): Promise<AxiosResponse> {
        return this.setUpAxios().post(url, payload, options);
    }

    public put = (url: string, payload: object, options?: AxiosRequestConfig): Promise<AxiosResponse> => {
        return this.setUpAxios().put(url, payload, options);
    }

    public del = (url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> => {
        return this.setUpAxios().delete(url, options);
    }

    private generateQR = async (text:string) => {
        try {
            return await QRCode.toDataURL(text)
        } catch (err) {
            return Promise.reject(err);
        }
    }

    public getQRCodeUrl = async () => {
        return await this.generateQR(`${globalThis.location.origin}${(SignUpStepRoutes[SignUpSteps.REDIRECTOR])}`)
    }
}

const HTTP = new HTTPService();

export default HTTP
